import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function ArtaProblem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-212">
      <div className="max-w-4xl mx-auto px-6" data-id="element-213">
        <SectionHeading title="Simți că ești mereu pe fugă și nu mai ai timp nici pentru tine?" data-id="element-214" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-215">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-216">
            <p className="font-bold text-xl text-brand-text" data-id="element-217">
              Te trezești dimineața deja obosit/ă. Ziua e o cursă în care alergi
              de la o sarcină la alta.
            </p>
            <p data-id="element-218">
              Mintea nu se oprește niciodată. Gânduri, liste, scenarii, griji.
              Îți spui că o să te relaxezi la weekend, dar vine weekendul și nu
              reușești nici atunci. Te pui mereu pe ultimul loc. Și simți că
              viața trece pe lângă tine fără să o trăiești cu adevărat.
            </p>
            <p data-id="element-219">
              Cu fiecare săptămână în care continui așa, oboseala se adâncește.
              Corpul începe să cedeze, relațiile se tensionează și energia
              dispare. Nu mai simți că trăiești, ci doar funcționezi. Iar cel
              mai mare preț pe care îl plătești nu e timpul pierdut. E bucuria,
              liniștea și sănătatea pe care le sacrifici zi de zi fără să îți
              dai seama.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-220">
              <p className="font-medium text-brand-text italic" data-id="element-221">
                Cursul Arta de a Trăi o Viață Fără Stres te învață cum
                funcționează stresul, ce tipuri de stres ai în viața ta și cum
                să le gestionezi concret. Primești tehnici simple de respirație
                și calmare a minții pe care le poți folosi chiar și într-un
                program aglomerat, exerciții de reglare emoțională și metode de
                a crea obiceiuri care îți susțin liniștea și energia în fiecare
                zi. Scopul nu e să elimini stresul complet, ci să înveți să
                rămâi în echilibru chiar și în mijlocul vieții.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-222">
          <CTAButton data-id="element-223" />
        </motion.div>
      </div>
    </section>;
}